"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableField = void 0;
const react_1 = __importStar(require("react"));
const react_sortable_hoc_1 = require("react-sortable-hoc");
const react_use_measure_1 = __importDefault(require("react-use-measure"));
const react_window_1 = require("react-window");
const Grid_1 = __importDefault(require("@material-ui/core/Grid"));
const table_field_styles_1 = require("./table-field-styles");
const table_field_context_1 = require("./table-field-context");
const table_field_hook_1 = require("./table-field-hook");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
exports.TableField = react_1.forwardRef(function TableField(options, ref) {
    var _a;
    const classes = table_field_styles_1.useStyles();
    const { props, selectedIndex, setSelectedIndex, context, formDialogRef, removeDialogRef, swapRows, toggleSortColumn, } = table_field_hook_1.useTableField(options);
    const { RowComponent, showToolbar, ToolbarComponent, HeaderComponent, FormFieldsComponent, DialogComponent, RemoveDialogComponent, ListWrapperComponent, FooterComponent, } = props;
    /**
     * Reference to VariableSizeList
     */
    const listRef = react_1.useRef(null);
    /**
     * Map of each mounted item height.
     */
    const itemHeightMap = react_1.useRef({});
    const maxHeight = props.maxRows * 30;
    const getItemHeight = event_callback_hook_1.useEventCallback((index) => itemHeightMap.current[index] || 30);
    /**
     * Height of VariableSizeList, dynamically changed between `defaultRowHeight` and `maxListHeight`.
     */
    const [listHeight, setListHeight] = react_1.useState(context.value.length * 30);
    const computeListHeight = event_callback_hook_1.useEventCallback((itemIndex) => {
        if (listRef.current && itemIndex !== undefined) {
            listRef.current.resetAfterIndex(itemIndex);
        }
        let newListHeight = 0;
        for (const key in itemHeightMap.current) {
            newListHeight += itemHeightMap.current[key];
        }
        if (newListHeight > maxHeight) {
            newListHeight = maxHeight;
        }
        setListHeight(newListHeight);
    });
    react_1.useEffect(() => {
        setListHeight(context.value.length * 30);
        itemHeightMap.current = {};
        context.value.forEach((_, i) => {
            itemHeightMap.current[i] = 30;
        });
        computeListHeight();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [(_a = props.value) === null || _a === void 0 ? void 0 : _a.length]);
    const SortableVariableSizeList = react_1.useMemo(() => react_sortable_hoc_1.SortableContainer(function List(props) {
        return react_1.default.createElement(react_window_1.VariableSizeList, Object.assign({}, props, { ref: listRef }));
    }), []);
    const SortableItem = react_sortable_hoc_1.SortableElement(function Row(props) {
        const { index, style, data } = props.nestedProps;
        const { value, selectedIndex } = data;
        const [rowRef, { height }] = react_use_measure_1.default();
        react_1.useEffect(() => {
            if (!!height && height !== itemHeightMap.current[index]) {
                itemHeightMap.current[index] = height;
                computeListHeight(index);
            }
            // eslint-disable-next-line react-hooks/exhaustive-deps
        }, [height]);
        return (react_1.default.createElement("div", { style: { ...style } },
            react_1.default.createElement(RowComponent, { value: value[index], index: index, selected: selectedIndex === index, ref: rowRef })));
    });
    const renderItem = react_1.useCallback((props) => {
        const { index } = props;
        // we need to post the props inside, so the index prop is not discarted by 'react-sortable-hoc'
        return react_1.default.createElement(SortableItem, { index: index, nestedProps: props });
    }, []);
    react_1.useImperativeHandle(ref, () => ({
        selectedIndex,
        setSelectedIndex,
    }), [selectedIndex, setSelectedIndex]);
    // we need real width of the header for the react-window wrapper
    const [measureRef, { width }] = react_use_measure_1.default();
    return (react_1.default.createElement(table_field_context_1.TableFieldSelectedContext.Provider, { value: { selectedIndex } },
        react_1.default.createElement(table_field_context_1.TableFieldContext.Provider, { value: context },
            react_1.default.createElement("div", { className: classes.componentWrapper },
                showToolbar && (react_1.default.createElement(ToolbarComponent, { selectedIndex: selectedIndex, setSelectedIndex: setSelectedIndex })),
                react_1.default.createElement(Grid_1.default, { container: true, className: classes.grid },
                    react_1.default.createElement("div", { className: classes.tableWrapper },
                        react_1.default.createElement(HeaderComponent, { ref: measureRef, onColumnClick: toggleSortColumn }),
                        react_1.default.createElement("div", { className: classes.dataWrapper, style: { maxHeight, width } },
                            react_1.default.createElement(ListWrapperComponent, null,
                                react_1.default.createElement(SortableVariableSizeList, { useDragHandle: true, onSortEnd: swapRows, height: Math.min(maxHeight, listHeight), width: "100%", style: {
                                        overflowX: 'hidden',
                                        overflowY: 'auto',
                                    }, itemSize: getItemHeight, estimatedItemSize: 30, itemData: {
                                        value: context.value,
                                        selectedIndex,
                                    }, itemCount: context.value.length }, renderItem))))),
                FooterComponent && react_1.default.createElement(FooterComponent, null),
                FormFieldsComponent !== undefined && (react_1.default.createElement(DialogComponent, { ref: formDialogRef, index: selectedIndex, FormFieldsComponent: FormFieldsComponent, value: selectedIndex !== undefined
                        ? context.value[selectedIndex]
                        : null })),
                react_1.default.createElement(RemoveDialogComponent, { ref: removeDialogRef, index: selectedIndex })))));
});
//# sourceMappingURL=table-field.js.map